// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';

/** Signs in with the id from an emailed sign-in link. */
export async function loginWithMagicLink(linkID: string): Promise<void> {
  await api.post('/auth/magic-link/login', { linkId: linkID });
}
